import React from 'react';
import LegalLayout from '../components/common/LegalLayout';

const TermsPage = () => (
  <LegalLayout
    title="이용약관"
    subtitle="ElectroWave Club 서비스 이용에 관한 권리·의무 및 책임사항을 규정합니다."
    helmetDescription="ElectroWave Club 이용약관 — 회원 / 멘토와 클럽 사이의 권리·의무, 매칭 진행 방식, 책임 범위, 분쟁 해결 절차."
    accentColor="#6366f1"
  >
    <h2>제1조 (목적)</h2>
    <p>
      본 약관은 ElectroWave Club(이하 "클럽")이 제공하는 멘토-학생 매칭 및 학습 진행 서비스(이하 "서비스")의
      이용과 관련하여 클럽과 회원의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
    </p>

    <h2>제2조 (정의)</h2>
    <ul>
      <li>① <strong>"클럽"</strong>이란 본 서비스를 운영하는 ElectroWave Club을 말합니다.</li>
      <li>② <strong>"회원"</strong>이란 본 약관에 동의하고 서비스를 이용하는 자(학생 또는 멘토)를 말합니다.</li>
      <li>③ <strong>"학생"</strong>이란 멘토와 매칭되어 학습을 진행하는 회원을 말합니다.</li>
      <li>④ <strong>"멘토"</strong>란 클럽의 검토를 거쳐 학생에게 코드 리뷰·페어 프로그래밍 등을 제공하는 회원을 말합니다.</li>
      <li>⑤ <strong>"매칭"</strong>이란 운영자가 학생과 멘토를 연결하는 절차를 말합니다.</li>
    </ul>

    <h2>제3조 (약관의 효력 및 변경)</h2>
    <p>
      ① 본 약관은 회원이 가입 시 동의함으로써 효력이 발생합니다.
    </p>
    <p>
      ② 클럽은 필요 시 약관을 변경할 수 있으며, 변경된 약관은 시행 7일 전(이용자에게 불리한 변경의 경우
      30일 전)까지 본 페이지를 통해 공지합니다.
    </p>
    <p>
      ③ 회원은 변경된 약관에 동의하지 않을 경우 회원 탈퇴 및 매칭 종료를 요청할 수 있습니다.
    </p>

    <h2>제4조 (이용계약의 성립)</h2>
    <p>
      ① 이용계약은 신청자가 본 약관에 동의하고 가입 신청을 한 후, 클럽이 이를 승인함으로써 성립합니다.
    </p>
    <p>
      ② 클럽은 다음 각 호에 해당하는 신청에 대해서는 승인을 거부하거나 사후 해지할 수 있습니다.
    </p>
    <ul>
      <li>타인의 명의를 도용하여 신청한 경우</li>
      <li>허위 정보 또는 클럽이 제시한 정보를 누락하여 신청한 경우</li>
      <li>이전에 본 약관에 의해 회원자격을 상실한 적이 있는 경우</li>
      <li>기타 클럽의 운영 정책에 위배되는 경우</li>
    </ul>

    <h2>제5조 (회원의 의무)</h2>
    <ul>
      <li>① 회원은 본 약관 및 클럽이 안내하는 운영 정책을 준수하여야 합니다.</li>
      <li>② 회원은 가입 시 입력한 정보가 변경된 경우 즉시 운영자에게 알려야 합니다.</li>
      <li>③ 회원은 본인의 계정 및 학습 자료를 타인에게 양도·임대할 수 없습니다.</li>
      <li>④ 회원은 매칭된 상대방(멘토 또는 학생)을 존중하고, 학습과 무관한 사적 거래·요청을 하지 않습니다.</li>
      <li>⑤ 회원은 멘토링 과정에서 알게 된 상대방의 개인정보를 외부에 유출하지 않습니다.</li>
      <li>⑥ <strong>학생은 사전에 약속된 정기 미팅 시간을 지킬 의무가 있으며</strong>, 부득이한 일정
        변경은 미팅 시작 24시간 전까지 멘토에게 통보하여야 합니다. 사전 통보 없는 미참여(노쇼) 또는
        반복적인 일정 변경은 해당 회차의 진행 처리 및 매칭 종결 사유가 될 수 있으며, 자세한 기준은{' '}
        <a href="/refund-policy">환불 정책</a>을 따릅니다.</li>
    </ul>

    <h2>제6조 (멘토의 의무)</h2>
    <ul>
      <li>① 멘토는 사전 약속한 정기 미팅 시간을 성실히 지킵니다.</li>
      <li>② 멘토는 학생에게 부당한 비용을 별도 청구하거나 외부 거래를 권유하지 않습니다.</li>
      <li>③ 멘토는 학생이 작성한 코드·문서에 대한 저작권을 주장하지 않습니다.</li>
      <li>④ 멘토는 정기 미팅 녹화본·채팅 로그·학생이 제출한 코드·문서를 <strong>학생 학습 자료 정리
        목적 외에는 사용하지 않으며, 어떠한 형태로든 외부에 공개·공유·배포하지 않습니다.</strong> 본
        의무는 매칭 종료 이후에도 유지됩니다.</li>
    </ul>

    <h2>제7조 (클럽의 의무)</h2>
    <ul>
      <li>① 클럽은 회원이 안전하게 서비스를 이용할 수 있도록 운영상 노력을 다합니다.</li>
      <li>② 클럽은 학생-멘토 매칭이 원활히 이루어지지 않을 경우 다른 멘토 후보를 안내합니다.</li>
      <li>③ 클럽은 회원의 개인정보를 별도의 <a href="/privacy-policy">개인정보 처리방침</a>에 따라 보호합니다.</li>
    </ul>

    <h2>제8조 (서비스의 제공 / 변경 / 중지)</h2>
    <p>
      ① 클럽은 안정적인 서비스 제공을 위해 정기 점검을 시행할 수 있으며, 이 경우 사전에 공지합니다.
    </p>
    <p>
      ② 클럽은 천재지변, 전시·사변, 정보통신 설비의 장애 등 부득이한 사유가 있는 경우 서비스 제공을
      일시 중지할 수 있습니다.
    </p>
    <p>
      ③ 클럽은 운영상 또는 기술상 사유로 서비스를 변경할 수 있으며, 중요한 변경 사항은 사전에 공지합니다.
    </p>

    <h2>제9조 (회비 및 환불)</h2>
    <ul>
      <li>① 클럽은 학생-멘토 매칭만을 중개하며, 회비는 <strong>학생이 매칭된 멘토에게 직접 입금</strong>하는
        방식으로 정산됩니다. 클럽은 회비를 위탁 보관·대리 수령하지 않습니다.</li>
      <li>② 회비는 <strong>매월 4회차(주 1회 기준 한 달치)를 기본 단위로 선불 납부</strong>하며, 회비
        산정 기준은 <a href="/tuition">회비 안내</a>, 환불 절차와 기준은{' '}
        <a href="/refund-policy">환불 정책</a>을 따릅니다.</li>
      <li>③ <strong>매칭 수수료는 멘토가 클럽에 납부</strong>하며 학생에게 별도 청구되지 않습니다. 다만
        첫 달 환불 시 회수가 어려운 매칭 수수료 등 운영 비용은 환불액에서 차감될 수 있습니다.</li>
      <li>④ 본 서비스는 단순 매칭 형태로 운영되므로, 별도의 플랫폼 사용료·입회비·세금계산서 발행은
        제공되지 않습니다.</li>
    </ul>

    <h2>제10조 (지식재산권 및 자료 공개)</h2>
    <ul>
      <li>① 멘토(교사)가 학생에게 제공한 예제 코드·강의 자료·문서·슬라이드 등 <strong>콘텐츠의 소유권 및
        저작권은 멘토에게 귀속</strong>합니다.</li>
      <li>② 학생이 멘토의 자료를 참고·활용하여 직접 작성한 코드·문서·포트폴리오 등 <strong>산출물의
        저작권은 학생에게 귀속</strong>합니다. 다만 산출물 안에 멘토 원본 자료가 그대로 포함된 부분에 대한
        권리는 그대로 멘토에게 남습니다.</li>
      <li>③ 멘토에게 제공받은 자료는 개인 학습 목적으로만 사용할 수 있으며, <strong>멘토의 사전 동의(서면
        또는 이에 준하는 명시적 동의) 없이 외부 공개·게시·복제·배포·재가공할 수 없습니다.</strong> 본
        의무는 회원 자격 종료 이후에도 유지됩니다.</li>
      <li>④ 학생이 자신의 산출물을 공개할 경우에도, 멘토 자료가 식별 가능한 형태로 포함되어 있다면
        해당 부분에 대해서는 멘토의 별도 동의를 받아야 합니다.</li>
      <li>⑤ <strong>정기 미팅 녹화본</strong>은 학생의 자료 정리·복습 목적으로 기본 보관됩니다.
        녹화본은 <strong>해당 매칭의 학생과 멘토 외 제3자에게 공유·전달할 수 없으며, 외부 공개·게시·
        배포·재가공도 일절 금지</strong>합니다. 본 의무는 <strong>학생과 멘토 모두에게 동일하게 적용</strong>되며,
        매칭 종료 이후에도 유지됩니다. 클럽은 운영·분쟁 대응 목적에 한해 녹화본에 접근할 수 있습니다.</li>
      <li>⑥ 클럽 웹사이트의 디자인·로고·텍스트 등은 클럽의 자산이며, 무단 사용을 금합니다.</li>
    </ul>

    <h2>제11조 (책임 제한)</h2>
    <p>
      ① 클럽은 천재지변 또는 이에 준하는 불가항력으로 인해 서비스를 제공할 수 없는 경우 책임을 지지
      않습니다.
    </p>
    <p>
      ② 클럽은 회원의 귀책사유로 인한 서비스 이용 장애에 대해서는 책임을 지지 않습니다.
    </p>
    <p>
      ③ 멘토와 학생 간의 학습 외 사적 거래로 발생한 손해에 대해서는 클럽이 책임지지 않습니다.
    </p>

    <h2>제12조 (분쟁의 해결)</h2>
    <p>
      ① 본 약관에 명시되지 않은 사항은 「전자상거래 등에서의 소비자 보호에 관한 법률」, 「약관의 규제에
      관한 법률」 등 관련 법령 및 상관례에 따릅니다.
    </p>
    <p>
      ② 본 약관과 관련하여 발생한 분쟁은 우선 양측의 합의로 해결하며, 합의가 어려울 경우 관련 분쟁조정
      기관 또는 관할 법원의 절차를 따릅니다.
    </p>

    <h2>부칙</h2>
    <p>
      본 약관은 2026년 5월 3일부터 적용됩니다.
    </p>
  </LegalLayout>
);

export default TermsPage;
